import { usePage } from '@inertiajs/react';
import { useEffect, useRef } from 'react';

import { Sentry } from '@/lib/sentry';
import type { PageProps } from '@/types';

export function useSentryIdentify(enabled = true): void {
  const { identity } = usePage<PageProps>().props;
  const identityIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!identity) {
      Sentry.setUser(null);
      identityIdRef.current = null;
      return;
    }

    if (identityIdRef.current === identity.id) {
      return;
    }

    const email = typeof identity.email === 'string' ? identity.email : undefined;

    Sentry.setUser({
      id: identity.id,
      email,
      username: identity.$display_name
    });

    identityIdRef.current = identity.id;
  }, [enabled, identity]);
}
